import(/* webpackMode: "eager" */ "/app/fo/src/app/error.tsx");
